import React, { useEffect, useState } from "react";
import HeartIcon from '../assets/icons/HeartIcon';
import { useTranslation } from 'react-i18next';
import { _Api } from "../../common/api";
import { Link } from "react-router-dom";
import WishlishHandler from "Ecommerce/template_four/components/WishlishHandler";

import './BestSellerItems.scss';

export default function BestSellerItems() {  
    const { t } = useTranslation();
    let isArabic = localStorage.getItem('i18nextLng');

    const [bestSellersData, setBestSellersData] = useState([]);
    const [bestSellerCardDetails, setBestSellerCardDetails] = useState([]);
    const [card, setCard] = useState([]);
    const [filterTag, setFilterTag] = useState('');
    const [keyIcon, setKeyIcon] = useState(null);
    const [wishlistdata, setWishlistData] = useState({ id: "", remove: false, edit: false });
    const [loading, setLoading] = useState(true);

    const fetchBestSellers = async () => {
      setLoading(true);
      try {
          let postData = {};
          let res = await _Api(postData, `product/best-seller`);
  
          if (res && res.statusCode === 200) {
              setBestSellersData(Array.isArray(res.items) ? res.items : []);
              setBestSellerCardDetails(Array.isArray(res.data) ? res.data : []);
          } else {
              setBestSellersData([]);
              setBestSellerCardDetails([]);
          }
      } catch {
          setBestSellersData([]);
          setBestSellerCardDetails([]);
      } finally {
          setLoading(false);
      }
  };
  


    useEffect(() => {
        if (filterTag) {
            const filteredProducts = bestSellerCardDetails.filter(product =>
                product.Item.toLowerCase() === filterTag.toLowerCase()
            );
            setCard(filteredProducts);
        }
        if(filterTag === ''){
          setCard(bestSellerCardDetails);

        }
    }, [filterTag, bestSellerCardDetails]);

    useEffect(() => {
        fetchBestSellers();
    }, []);

    return (
        <>

            <div className="ecommerce-homepage-bestsellers-items">
                {bestSellersData.length > 0 ? bestSellersData.map((item, key) => (
                    <div
                        key={key}
                        className={`ecommerce-homepage-bestsellers-items-button ${keyIcon === key ? 'active' : ''}`}
                        onClick={() => { setFilterTag(item); setKeyIcon(key); }}
                    >
                        {t(`${item}`)}
                    </div>
                )) : null}
            </div>

            <div className="ecommerce-homepage-bestsellers-collection">
            <div className="ecommerce-main-layout-products-container-show-all_products tempatethreebestsellers">
                {card.length ? card.map((item, key) => (
                    <Link to={`/product/${item?.Slug}`} state={{ id: item?._id }} className='ecom-productcard' key={key}>
                        <div className='ecom-productcard-image'>
                            <div className="ecom-productcard-image-imgBoxShow">
                                <img src={item?.images[0]?.original || ""} alt='product' />
                            </div>
                            <div className={isArabic === 'arabic' ? 'heartIconBoxrtl' : 'heartIconBox'} onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
                                {item?.isWishlist ?
                                    <i onClick={() => setWishlistData({ id: item?._id, add: false, remove: true, index: key })}
                                        className="fa fa-sharp fa-solid fa-heart text-danger"
                                        style={{ fontSize: "20px" }}
                                    ></i> :
                                    <span onClick={() => setWishlistData({ id: item?._id, add: true, remove: false, index: key })}>
                                        <HeartIcon color={"black"} width={24} height={24} />
                                    </span>
                                }
                            </div>
                        </div>
                        <div className="ecom-productcard-details text-decoration-none ">
                            <div className='ecom-productcard-details-wrapper'>
                                <div className="ecom-productcard-details-wrapper-productName">
                                    {item?.name}
                                </div>
                                <span>{item?.SKU} </span>
                                <div className="ecom-productcard-details-wrapper-colorthemewrapper">
                                    {item?.MetalData?.map((itm, index) => (
                                        <div className="coloritems" key={index} style={{ backgroundImage: `radial-gradient(circle, #ffff , ${itm.colorCode || '#fff'},${itm.colorCode || '#fff'})` }}>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className='ecom-productcard-price'>
                                {item?.price}
                            </div>
                        </div>
                    </Link>
                )) : (
                    <div className="result-data-empty">
                        <h1>Oops! We can't find products matching the selection.</h1>
                    </div>
                )}
            </div>
            </div>
            <WishlishHandler
        wishlistdata={wishlistdata}
        productdata={bestSellerCardDetails}
        setProductdata={setBestSellerCardDetails}
        />
        </>
    );
}
